<template>
  <div class="home" :key="key">
    <!-- <v-container fluid> -->
    <!-- <p>{{ radio || "null" }}</p> -->
    <!-- style="padding-left: 24px; padding-right: 24px; padding-bottom: 4px" -->
    <v-row class="d-flex flex-no-wrap justify-space-around align-center">
      <v-radio-group v-model="radio" row mandatory @change="radiochanged" dense>
        <v-radio label="Cards" value="Cards"></v-radio>
        <v-radio label="Table" value="Table"></v-radio>
      </v-radio-group>
      <v-btn @click="getAirbox" rounded small
        ><v-icon small>mdi-refresh</v-icon>REFRESH</v-btn
      >
    </v-row>
    <div style="padding-left: 12px; padding-right: 12px">
      <v-toolbar dark color="blue darken-3">
        <v-select
          v-model="selectedBox"
          :items="selectEventList"
          menu-props="auto"
          single-line
          dense
          hint="Pilots in selected box - ( ALL is pilots in all boxes )"
          persistent-hint
          @change="selectBoxChanged()"
          color="blue"
        ></v-select>
      </v-toolbar>
    </div>
    <div v-if="radionumber == 1">
      <AirboxCard :items="items"></AirboxCard>
    </div>
    <div v-if="radionumber == 2">
      <AirboxTable :items="items"></AirboxTable>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import AirboxTable from "@/components/airbox/AirboxTable.vue";
import AirboxCard from "@/components/airbox/AirboxCard.vue";

export default {
  name: "Airbox",
  data() {
    return {
      eventId: 0,
      radio: null,
      radionumber: Number,
      items: [],
      errors: [],
      eventList: [],
      selectEventList: [],
      selectedBox: { value: 0, text: "ALL" },
      loading: true,
      key: Number,
      // selectedBox: String,
      badgeIcon: String,
      badgeColor: String,
    };
  },
  created() {
    this.eventId = this.$route.params.eventId;
    if (this.eventId == null) {
      this.eventId = 0;
    }
    // if (this.eventId == 0) {
    //   this.selectedBox = [{value: 0, text: "ALL"}]
    // }
    this.radionumber = 1;
    this.badgeIcon = "mdi-lock-outline";
    this.badgeColor = "red";
    this.getAirboxList();
    this.getAirbox();
    this.key = 1;
  },
  methods: {
    getAirboxList() {
      axios
        // .get("http://localhost:3000/dbapi/getBoxesWithPilots")
        .get("https://pgapi.azurewebsites.net/dbapi/getBoxesWithPilots")
        // .get("https://pgapi.azurewebsites.net/dbapi/lsb/" + this.eventId)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.eventList = response.data;
          // console.log("eventList", this.eventList);
          for (var i = 0; i < this.eventList.length; i++) {
            // this.selectEventList.push(this.eventList[i].EventDescription);
            this.selectEventList.push({
              value: this.eventList[i].EventId,
              text:
                this.eventList[i].Event +
                " / " +
                this.eventList[i].EventDescription,
            });
            if (this.eventList[i].EventId == this.eventId) {
              this.selectedBox = {
                value: this.eventList[i].EventId,
                text: this.eventList[i].EventDescription,
              };
              // console.log("selected box in getAirboxList", this.selectedBox);
            }
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    getAirbox() {
      axios
        // .get('http://localhost:3000/dbapi/lsb/" + this.eventId)')
        .get("https://pgapi.azurewebsites.net/dbapi/lsb/" + this.eventId)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.items = response.data;
          this.getCookies();
          this.loading = false;
          let arr = this.items;
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].RegId == this.cookieRegId) {
              this.items[i].Enabled = this.loggedIn;
            }
          }
          this.items = arr;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    radiochanged() {
      if (this.radio == "Cards") {
        this.radionumber = 1;
      }
      if (this.radio == "Table") {
        this.radionumber = 2;
      }
    },
    selectBoxChanged() {
      // console.log("selected box", this.selectedBox);
      this.eventId = this.selectedBox;
      this.getAirbox();
    },
    getCookies() {
      this.cookieRegId = this.$cookies.get("pgbregid");
      this.cookieToken = this.$cookies.get("pgbtoken");
      this.regid = this.cookieRegId;
      // this.ac = this.cookieToken;
      if (this.cookieToken > 0) {
        this.loggedIn = true;
        this.badgeIcon = "mdi-lock-open";
        this.badgeColor = "green";
      }
    },
    refresh() {
      this.key++;
    },
  },
  components: {
    // Lsb,
    // LsbCard,
    AirboxTable,
    AirboxCard,
  },
};
</script>